<template>
  <div>
    <artzie-modal v-model="showModal" />

    <div v-if="$vuetify.breakpoint.mdAndUp && $app.showStickyArtzie" class="artize-sticky-container">
      <div class="artzie-box">
        <img class="artzie-avatar" src="./artzie_logo.png" alt="Artzie" />
        <div class="close-btn">
          <tk-btn small icon fab dark color="black" @click="$app.showStickyArtzie = false">
            <v-icon size="14">fas fa-times</v-icon>
          </tk-btn>
        </div>

        <div class="artzie-box__content">
          <div
            class="text-xs-center artzie-box__content_inner pb-3 px-3 elevation-5"
          >
            <div class="body-1 font-weight-bold pb-1">
              {{ $t("HOME.ARTZIE.TITLE") }}
            </div>
            <tk-btn block dark color="black" @click="showModal = true">
              <span class="caption font-weight-medium">{{
                $t("HOME.ARTZIE.BUTTON")
              }}</span>
            </tk-btn>
          </div>
        </div>
      </div>
    </div>

    <div class="ArtzieBox" @click="showModal = true">
      <div class="ArtzieBox__container">
        <div class="ArtzieBox__illustration">
          <img src="./Artzie.png" alt="Artzie" />
        </div>
        <div class="ArtzieBox__logo">
          <img :src="logo" alt="artzie-logo" />
        </div>
        <div class="ArtzieBox__content" v-text="t.content" />
        <div class="ArtzieBox__btn-container">
          <tk-btn dark color="black" large class="ArtzieBox__button">
            <span class="caption font-weight-medium">{{ t.button }}</span>
          </tk-btn>
        </div>
      </div>
      <artzie-modal v-model="showModal" />
    </div>
  </div>
</template>

<script>
import ArtzieModal from '@/components/Domain/Artzie/ArtzieModal'
import LogoEn from './artzie_logo_en_cut.png'
import LogoFi from './artzie_logo_fi_cut.png'
import LogoSe from './artzie_logo_se_cut.png'

const localeLogos = {
  en :LogoEn,
  fi :LogoFi,
  se :LogoSe
}

export default {
  components: { ArtzieModal },
  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    t() {
      return {
        content: this.$t(
          "LITERAL['Terve! Nimeni on Artzie, Taikon virtuaalinen taideopas. Testaa, miten voin auttaa sinua löytämään juuri sinulle sopivan taideteoksen!']"
        ),
        button: this.$t("LITERAL['LÖYDÄ SOPIVA TEOS']"),
      };
    },
    logo() {
      return localeLogos[this.$i18n.locale];
    },
  },

  mounted() {
    const shouldOpenArtzie = this.$route.meta.openArtzie;
    if (shouldOpenArtzie) {
      this.showModal = true;
    }
  },
};
</script>

<style lang="scss">
.artize-sticky-container {
  position: fixed;
  top: 180px;
  right: 10px;
  z-index: 3;

  .artzie-box {
    width: 170px;
    text-align: center;
    border: 1px;
    position: relative;

    .close-btn {
      position: absolute;
      right: 0;
      top: 0;

      button {
        height: 32px;
        width: 32px;
      }
    }

    .artzie-avatar {
      max-width: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
    }

    &__content {
      padding-top: 93%;

      &_inner {
        padding-top: 36px;
        background: #ffffff;
      }
    }
  }
}

@import "./src/components/base/smart-grid";
@import "src/components/base/Btn/BaseButtonBlack";

.ArtzieBox {
  position: relative;
  padding: 0 67px;
  cursor: pointer;

  @include lg-block {
    padding-bottom: 41px;
  }
  @include md-block {
    padding-left: 23px;
    padding-right: 23px;
  }

  &::before {
    content: "";
    background: #faf3eb;
    left: 0;
    right: 0;
    bottom: 32px;
    top: 32px;
    position: absolute;
    z-index: 1;

    @include lg-block {
      bottom: 0;
    }
  }

  &__container {
    z-index: 2;
    justify-content: space-between;
    align-items: center;
    position: relative;
    display: grid;
    grid-template-areas: "illustration logo content btn-container";
    grid-gap: 32px;

    justify-items: center;

    @include lg-block {
      grid-template-areas:
        "illustration content logo"
        "illustration content btn-container  ";
      align-items: flex-start;
    }

    @include md-block {
      grid-template-areas:
        "illustration  logo"
        "content content"
        "btn-container btn-container";
      justify-content: center;
    }

    @include xs-block {
      grid-template-areas:
        "illustration illustration  logo"
        "content content content"
        "btn-container btn-container btn-container";
      justify-content: center;
    }
  }

  &__content {
    max-width: 317px;
    color: #212121;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    grid-area: content;
    @include lg-block {
      padding-top: 41px + 32px;
      align-self: center;
      text-align: center;
    }
    @include md-block {
      padding-top: 0;
      align-self: center;
    }
  }

  &__logo {
    grid-area: logo;
    margin-left: -20px;
    img {
      width: 149px;
      @include xs-block {
        max-width: 100%;
      }
    }

    @include lg-block {
      padding-top: 41px + 32px;
      margin-left: 0;
    }
    @include md-block {
      align-self: center;
      margin-left: -20px;
    }
  }

  &__illustration {
    grid-area: illustration;
    @include xs-block {
      img {
        max-width: 100%;
      }
    }
  }

  &__btn-container {
    grid-area: btn-container;
  }

  &--lg {
    background: #626262;
  }

  &__button {
    @include BaseButtonBlack;
    &.v-btn {
      font-size: 0.8rem;
      min-width: 215px;
      min-height: 58px;
      @include md-block {
        margin: 0;
      }
      @include md-block {
        margin: 0;
      }
    }
  }

  &:hover {
    @include BaseButtonBlackHover;
  }

  &.is-mobile {
    @include BaseButtonBlackHover;
  }
}
</style>
